import { GraphSelectionModel } from "@features/graph/graphViewModel"

export const graphEdgeSelectionStyle = (id: string): string => {
  if (GraphSelectionModel.parentEdges.has(id)) return "gnc-edge-parent"
  if (GraphSelectionModel.childEdges.has(id)) return "gnc-edge-child"
  return "gnc-edge-selected"
}
